import { useState } from "react";

import { useApi, ApiError } from "../api/client";
import "./SmsTest.css";

/**
 * Super-admin gateway test: send a one-off test SMS to a number you type (your
 * own) to verify MessageMedia is configured. Bypasses the WFP_SMS_ENABLED master
 * switch server-side; costs one message. English-only for now (i18n follow-up).
 */
export function SmsTest() {
  const callApi = useApi();
  const [to, setTo] = useState("");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState<{ ok: boolean; message: string } | null>(
    null,
  );

  async function send() {
    if (!to.trim() || sending) return;
    setSending(true);
    setResult(null);
    try {
      await callApi<{ ok: boolean }>(`/admin/sms-test`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ to: to.trim() }),
      });
      setResult({ ok: true, message: "Sent — check the phone." });
    } catch (err) {
      const message =
        err instanceof ApiError
          ? err.status === 403
            ? "Super admins only."
            : err.status === 400
              ? "That doesn't look like a valid NZ mobile."
              : "Send failed — check the SMS settings (key/secret, base URL, enabled)."
          : "Send failed — please try again.";
      setResult({ ok: false, message });
    } finally {
      setSending(false);
    }
  }

  return (
    <section className="smstest">
      <h2 className="smstest__title">Send a test text (super admin)</h2>
      <p className="smstest__note">
        Verifies the MessageMedia connection. Texts the number you enter — use
        your own. Costs one message.
      </p>
      <div className="smstest__row">
        <input
          type="tel"
          inputMode="tel"
          className="smstest__input"
          placeholder="021 234 5678"
          value={to}
          onChange={(e) => setTo(e.target.value)}
          aria-label="Test mobile number"
        />
        <button
          type="button"
          className="smstest__btn"
          disabled={sending || !to.trim()}
          onClick={() => void send()}
        >
          {sending ? "Sending…" : "Send test"}
        </button>
      </div>
      {result && (
        <p className={result.ok ? "smstest__ok" : "smstest__err"} role="status">
          {result.message}
        </p>
      )}
    </section>
  );
}

export default SmsTest;
